import React from "react"
import Article from '../Article'

function TurnOn(props) {

  const content = `<p>Ao ligar o <strong>Monitor All in One WT55S</strong> (TOUK) o sistema operacional &eacute; iniciado, acesse o navegador do aparelho (de prefer&ecirc;ncia o google chrome);&nbsp;<br />
  <br/>
  Digite a URL fornecida e a tela do Simular ser&aacute; iniciada.&nbsp;</p>
  
  <p><img alt="" src="/images/como-ligar.png" style="height:220px; width:360px" /></p>
  
  <p>Caso tenha alguma d&uacute;vida sobre o aparelho, verifique o manual acessando o link abaixo:</p>`

  const button = {
    text:'ACESSAR GUIA TOUK',
    link:'https://xibo.org.uk/docs/setup/the-windows-player-automatically-restarts-itself-windows-player-watchdog'
  }
  return (
    <Article article={content} title='Como ligar' button={button}/>
    )
  
}

export default TurnOn
